"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDataView = exports.isArrayBuffer = void 0;
function isArrayBuffer(object) {
    return (object instanceof ArrayBuffer ||
        toString.call(object) === "[object ArrayBuffer]");
}
exports.isArrayBuffer = isArrayBuffer;
function isDataView(object) {
    return (object instanceof DataView || toString.call(object) === "[object DataView]");
}
exports.isDataView = isDataView;
//# sourceMappingURL=object.js.map